// NOTICE: Key matters :)
export const clientType = {
  Client: "Client",
  Agent: "Agent",
};
